export const SHOW_CONVERSATION_LIST = 'SHOW_CONVERSATIONS_LIST'
export const SHOW_CONVERSATION = 'SHOW_CONVERSATION'
export const CONVERSATION_CLICKED = 'CONVERSATION_CLICKED'

// Auth constants
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SIGNUP_USER = 'SIGNUP_USER'
export const FETCH_USER_DATA = 'FETCH_USER_DATA'
export const UPDATE_USER = 'UPDATE_USER'
export const IS_AUTH = 'IS_AUTH'

// Alert
export const ALERT = 'ALERT'
export const SHOW_ALERT = 'SHOW_ALERT'
export const CLOSE_ALERT = 'CLOSE_ALERT'

// CHAT
export const FETCH_CONVERSATION_PARTNERS = 'FETCH_CONVERSATION_PARTNERS'  // get a list of all users i have had a conversation with
export const FETCH_CONVERSATION = 'FETCH_CONVERSATION' //gets the conversation messages between two folks
export const CLEAR_ACTIVE_CONV_MSGS = 'CLEAR_ACTIVE_CONV_MSGS'
export const ACTIVE_CONV_PARTNER = 'ACTIVE_CONV_PARTNER'
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT'
export const SEARCH_USER = 'SEARCH_USER'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'

//SOCKET REAL TIME
export const SEND_NEW_MESSAGE = 'SEND_NEW_MESSAGE'
export const START_CHAT = 'START_CHAT'
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE'
export const ADD_NEW_MESSAGE_INACTIVE = 'ADD_NEW_MESSAGE_INACTIVE'